(() => {
  if (window.CAJBundleStickyCloseV3) return;
  window.CAJBundleStickyCloseV3 = true;

  const mount = (root) => {
    const picker = root.querySelector('[data-caj-bundle-picker]');
    const grid = picker?.querySelector('[data-caj-products-grid]');
    const btn = picker?.querySelector('.caj-bundle-picker__floating-close');
    if (!picker || !grid || !btn) return;

    let wrap = picker.querySelector('.caj-bundle-picker__sticky-close-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'caj-bundle-picker__sticky-close-wrap';
    }

    if (wrap.nextElementSibling !== grid) {
      grid.before(wrap);
    }

    if (btn.parentElement !== wrap) wrap.appendChild(btn);

    btn.classList.remove('is-following-scroll');
    btn.style.removeProperty('--caj-close-top');
    btn.style.removeProperty('--caj-close-left');
  };

  const mountAll = () => {
    document.querySelectorAll('[data-caj-bundle-v2]').forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll, { once:true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', mountAll);

  const observer = new MutationObserver(mountAll);
  observer.observe(document.documentElement, { childList:true, subtree:true });
})();
